import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { UsersPage } from "./pages/RestlessUsers/RestlessUsersPage";
import { IdentityVerificationPage } from "./pages/RestlessUsers/RestlessIdentityVerificationPage";
import { DashboardPage } from "./pages/DashboardPage";
import RestlessPostsPage from "./pages/RestlessContent/RestlessPostsPage";
import RestlessMediaPage from "./pages/RestlessContent/RestlessMediaPage";
import RestlessArticlesPage from "./pages/RestlessContent/RestlessArticlesPage";
import RestlessCommentsPage from "./pages/RestlessInteractions/RestlessCommentsPage";
import RestlessHashtagsPage from "./pages/RestlessInteractions/RestlessHashtagsPage";
import RestlessAnalyticsPage from "./pages/RestlessActivity/RestlessAnalyticsPage";
import RestlessHashtagsDetails from "./pages/RestlessInteractions/RestlessHashtags/RestlessHashtagsDetails";
import RestlessArticlesEditorPage from "./pages/RestlessContent/RestlessArticlesEditor/RestlessArticlesEditorPage";
import RestlessNotificationsPage from "./pages/RestlessNotifications/RestlessNotificationsPage";
import RestlessReportsPage from "./pages/RestlessReports/RestlessReportsPage";
import RestlessReportsReviewedPage from "./pages/RestlessReportsReviewed/RestlessReportsReviewedPage";
import RestlessPostEditorPage from "./pages/RestlessContent/RestlessPostEditor/RestlessPostEditor";
import RestlessNotificationsCreationPage from "./pages/RestlessNotifications/RestlessNotificationsCreationPage";

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/identityverification" />
        }
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/users" component={UsersPage} />
        <ContentRoute
          path="/identityverification"
          component={IdentityVerificationPage}
        />
        <ContentRoute path="/posts/editor/:id" component={RestlessPostEditorPage} />
        <ContentRoute path="/posts/new" component={RestlessPostEditorPage} />
        <ContentRoute path="/posts" component={RestlessPostsPage} />
        <ContentRoute
          path="/articles/:id/editor"
          component={RestlessArticlesEditorPage}
        />
        <ContentRoute
          path="/articles/new"
          component={RestlessArticlesEditorPage}
        />
        <ContentRoute path="/articles" component={RestlessArticlesPage} />
        <ContentRoute path="/media" component={RestlessMediaPage} />

        <ContentRoute path="/comments" component={RestlessCommentsPage} />
        <ContentRoute
          path="/hashtags/:hashtag/details"
          component={RestlessHashtagsDetails}
        />
        <ContentRoute path="/hashtags" component={RestlessHashtagsPage} />

        <ContentRoute path="/reports" component={RestlessReportsPage} />
        <ContentRoute
          path="/reviewedreports"
          component={RestlessReportsReviewedPage}
        />

        <ContentRoute path="/notifications/new" component={RestlessNotificationsCreationPage} />
        <ContentRoute path="/notifications" component={RestlessNotificationsPage} />
        

        <ContentRoute path="/analytics" component={RestlessAnalyticsPage} />
        <ContentRoute path="/activity" component={RestlessNotificationsPage} />

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
